@if (requiredRegimenClass === appConfig.Shared.Regimen.Class.HAIR) {
  <div class="tw-relative tw-font-body tw-rounded-2xl tw-mx-4 tw-pt-8 tw-shadow-z1 tw-bg-white tw-bg-grid-fade-rtl tw-bg-contain tw-bg-right-bottom tw-bg-no-repeat tw-overflow-hidden" (click)="onBannerClick()">
    <span class="tw-absolute tw-top-0 tw-left-5 tw-px-4 tw-py-2.5 tw-bg-teal-100 tw-border tw-border-dashed tw-border-teal-400 tw-text-300 tw-font-[700] -tw-mt-[2px] tw-text-teal-600" i18n="@@discountAmount">₹{{ discountAmount }} OFF!</span>
    @if (showDandruffBanner) {
      <div class="tw-w-full tw-flex tw-justify-between tw-py-4 tw-px-5 tw-mb-3">
        <div class="tw-w-[55%] tw-flex tw-flex-col">
          <h3 class="tw-text-700 tw-font-[700]" i18n="@@dandruff">Dandruff</h3>
          <p class="tw-text-400 tw-font-light tw-leading-6 tw-text-wrap tw-min-h-10" i18n="@@isReasonBehindAcne">can be the reason behind your acne!</p>
        </div>
        <div class="tw-flex tw-justify-center tw-items-center tw-mr-4">
          <img class="tw-w-20 tw-aspect-square tw-rounded-xl -tw-mr-5 -tw-mt-6" src="https://cdn.cureskin.com/app/img/crossSellImages/acne_1.jpg">
          <img class="tw-w-20 tw-aspect-square tw-rounded-xl -tw-ml-4 -tw-mb-8" src="https://cdn.cureskin.com/app/img/crossSellImages/dandruff_2.jpg">
        </div>
      </div>
    }
    @if (showHairThinningBanner) {
      <div class="tw-w-full tw-flex tw-justify-between tw-py-4 tw-px-5 tw-mb-3">
        <div class="tw-flex-1 tw-flex tw-flex-col tw-justify-center">
          <h3 class="tw-text-650 tw-font-[700]" i18n="@@hairThinning">Hair thinning</h3>
          <p class="tw-text-400 tw-font-light tw-leading-6 tw-min-h-10" i18n="@@commonDuringPregnancy">is common during pregnancy.</p>
        </div>
        <div class="tw-flex tw-justify-center tw-items-center tw-mr-2">
          <img class="tw-w-20 tw-aspect-square tw-rounded-xl -tw-mr-5 -tw-mt-6" src="https://cdn.cureskin.com/app/img/crossSellImages/pregnant_1.png">
          <img class="tw-w-20 tw-aspect-square tw-rounded-xl -tw-ml-4 -tw-mb-8" src="https://cdn.cureskin.com/app/img/crossSellImages/hairfall_2.png">
        </div>
      </div>
    }
    @if (showFallbackBanner) {
      <div class="tw-w-full tw-flex tw-py-4 tw-px-5">
        <div class="tw-flex-1 tw-flex tw-flex-col">
          <h3 class="tw-text-700 tw-font-[700]" i18n="@@controlHairfall">Control your <br/> hair fall</h3>
          <p class="tw-text-500 tw-font-light tw-leading-7 tw-text-gray-800" i18n="@@inEarlyStages">in early stages!</p>
        </div>
        <div class="tw-flex tw-justify-center tw-items-center">
          <img class="tw-w-28 tw-aspect-square tw-rounded-xl -tw-ml-3" src="https://cdn.cureskin.com/app/img/crossSellImages/weakHair.png">
        </div>
      </div>
    }
    <div class="tw-px-4 tw-pb-4">
      @if (!showDandruffBanner) {
        <span i18n="@@takeHairConsultation" class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden tw-text-nowrap">
        Take Hair Consultation Now
      </span>
      }
      @if (showDandruffBanner) {
        <span
          i18n="@@buyAntiDandruffKit"
          class="tw-w-full tw-bg-teal-600 tw-text-white tw-py-2 tw-px-8 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden tw-text-nowrap"
        >Buy Anti-dandruff Kit</span>
      }
    </div>
  </div>
}

@if (requiredRegimenClass === appConfig.Shared.Regimen.Class.FACE) {
  <div class="tw-px-4 tw-font-body">
    <div class="tw-relative tw-rounded-2xl tw-shadow-z1 tw-overflow-hidden tw-border tw-border-white tw-min-h-[25vh]" (click)="onBannerClick()">
      <span class="tw-z-[1] tw-absolute tw-top-0 tw-left-5 tw-px-4 tw-py-2.5 tw-bg-teal-100 tw-shadow-z1 tw-border tw-border-dashed tw-border-teal-400 tw-text-300 tw-font-[700] -tw-mt-[2px] tw-text-teal-600" i18n="@@discountAmount">₹{{ discountAmount }} OFF!</span>
      @if (user.get('Gender') === appConfig.Shared.Gender.FEMALE) {
        <img class="tw-z-0 tw-inset-0 tw-w-full tw-h-full tw-min-h-[25vh] tw-object-cover" src="https://cdn.cureskin.com/app/img/crossSellImages/faceCrossSellFemale.png" alt="bannerBg" />
      }
      @if (user.get('Gender') === appConfig.Shared.Gender.MALE) {
        <img class="tw-z-0 tw-inset-0 tw-w-full tw-h-full tw-min-h-[25vh] tw-object-cover" src="https://cdn.cureskin.com/app/img/crossSellImages/faceCrossSellMale.png" alt="bannerBg" />
      }
      <div class="tw-absolute tw-top-[58%] -tw-translate-y-1/2 tw-left-0 tw-w-[45%] tw-flex tw-pl-6 tw-z-[1] -tw-mb-[8%]">
        <div class="tw-flex tw-flex-col">
          <p class="tw-text-400 tw-font-light tw-mb-1 tw-text-nowrap" i18n="@@yourPersonalized">Your personalized</p>
          <h3 class="tw-text-[22px] tw-font-[700] tw-leading-6 tw-mb-4" i18n="@@skincareRoutine">Skincare Routine!</h3>
          <span i18n="@@startNow" class="tw-w-fit tw-bg-teal-600 tw-text-white tw-py-2.5 tw-px-5 tw-rounded-xl tw-text-300 tw-flex tw-justify-center tw-items-center tw-font-bold shine-button tw-relative tw-overflow-hidden">Start Now</span>
        </div>
      </div>
    </div>
  </div>
}
